import React, { useCallback } from 'react';
import { useRepresentativeImagesRedirectPath } from '../queries/useRepresentativeImagesRedirectPath';
import { bridge, isNil } from 'shared/src/utils';
import { Flex, RemoteImage } from '@banhala/ui-kit';
import { useGoodsSno } from '../../../hooks/useGoodsSno';

export const AiStudioRedirect: React.FC = () => {
  const { data } = useRepresentativeImagesRedirectPath();
  const goodsSno = useGoodsSno();

  const onPress = useCallback(() => {
    if (isNil(data)) return;

    if (isNil(data.deeplink)) return;
    bridge.openDeeplink(data.deeplink, { webCallback: () => {} });
    bridge.logAnalyticsEvent({
      name: 'CLICK_AI_FITTING',
      analytics: {
        GOODS_SNO: goodsSno.toString(),
      },
    });
  }, [data, goodsSno]);

  if (isNil(data)) return null;

  if (isNil(data.resource_image)) return null;

  return (
    <Flex onPress={onPress}>
      <RemoteImage
        uri={data.resource_image.image_url}
        height={data.resource_image.height}
        width={data.resource_image.width}
      />
    </Flex>
  );
};
